module.exports = __webpack_public_path__ + "static/media/login-bg-img.12ed2ea7.svg";